import React from 'react';
import { Hero } from '../components/Hero';
import { Problem } from '../components/Problem';
import { Solution } from '../components/Solution';
import { Deliverables } from '../components/Deliverables';
import { Pricing } from '../components/Pricing';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-background text-text-main selection:bg-primary selection:text-black overflow-x-hidden" data-id="element-166">
      <Hero data-id="element-167" />
      <Problem data-id="element-168" />
      <Solution data-id="element-169" />
      <Deliverables data-id="element-170" />
      <Pricing data-id="element-171" />
      <Footer data-id="element-172" />
    </main>;
}